import { css } from 'react-emotion';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { formValueSelector, reduxForm } from 'redux-form';
import validate from './validate';
import StepTitle from '../../../common/StepTitle';
import { NEW } from './SelectPartyStep';
import { actions as termActions } from '../../../../reducers/terms';
import ChooseNewOrExistingContractField from './ChooseNewOrExisting/ChooseNewOrExistingContractField';
import Loading from '../../../Loading';
import isEmpty from 'lodash/isEmpty';
import Button from '../../../common/Button';
import { withTranslation } from 'react-i18next';

const divStyle = css({
  marginBottom: '50px'
});

const prevButtonStyle = css({
  float: 'left'
});

const nextButtonStyle = css({
  float: 'right'
});

class SelectCreationTypeStep extends Component {
  state = {
    isLoading: false,
    isLoaded: false
  };

  componentDidMount() {
    const { fetchTermsByBuyerSeller, buyer, seller, handleSubmit } = this.props;
    this.setState({ isLoading: true }, () =>
      fetchTermsByBuyerSeller(buyer, seller)
        .then(({ payload }) => {
          // if no contracts found, skip to the next step.
          if (isEmpty(payload)) {
            this.props.change('creationType', NEW);
            handleSubmit();
            return;
          }

          this.setState({ isLoading: false, isLoaded: true });
        })
        // if contract fetch call fails, skip to the creation step.
        .catch(_ => {
          this.props.change('creationType', NEW);
          handleSubmit();
        })
    );
  }

  render() {
    const { handleSubmit, onPrev, seller, t } = this.props;
    const { isLoading } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    return (
      <div className={divStyle}>
        <StepTitle
          title={t('createContract:selectCreationTypeStep.header')}
          description={
            <span>
              {t('createContract:selectCreationTypeStep.existingContractsWarning', {
                name: seller.name
              })}
            </span>
          }
        />
        <ChooseNewOrExistingContractField seller={seller} t={t} />
        <form onSubmit={handleSubmit}>
          <span className={prevButtonStyle}>
            <Button className="btn btn-outline-primary" onClick={onPrev}>
              {t('common:commonWords.prev')}
            </Button>
          </span>
          <span className={nextButtonStyle}>
            <Button className="btn btn-primary">{t('common:commonWords.next')}</Button>
          </span>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const formSelector = formValueSelector('buyerCreateFlow');

  return {
    seller: formSelector(state, 'seller'),
    buyer: formSelector(state, 'buyer')
  };
}

const mapDispatchToProps = {
  fetchTermsByBuyerSeller: termActions.fetchTermsByBuyerSeller
};

SelectCreationTypeStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCreationTypeStep);

export default reduxForm({
  form: 'buyerCreateFlow',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(withTranslation()(SelectCreationTypeStep));
